module.exports = __webpack_public_path__ + "img/12_69.8098c655.png";